import { gql } from "@apollo/client"

import seoFields from "./partials/seoFields"
import sys from "./partials/sys"

export const pressReleasesId = "2NoTs1VwM81GyU9BPqxkPs"
export const pressReleasesCollection = `contentType${pressReleasesId}Collection`

export const GET_ALL_PRESS_RELEASES_QUERY = gql`
  query GetAllPressReleases($limit: Int!, $skip: Int!){
  ${pressReleasesCollection}(order: date_DESC, limit: $limit, skip: $skip){
      total
      items {
        sys {
          id
        }
        title
        date
        content
        slug
      }
    }
  }
`

export const GET_PRESS_RELEASES_SLUGS_QUERY = gql`
  query GetPressReleasesSlugs {
    ${pressReleasesCollection} {
      items {
        slug
      }
    }
  }
`

export const GET_PRESS_RELEASE_QUERY = gql`
query GetPressRelease($slug: String!, $preview: Boolean!) {
  ${pressReleasesCollection} (
    where: { slug: $slug }
    preview: $preview
    limit: 1
  ) {
    items {
      title
      date
      content
      slug
      seo {
        ${seoFields}
      }
      ${sys}
    }
  }
}
`
